<template>
  <div class="con-tablex vs-table--content">
    <table
      v-if="companyContactPartnersPage"
      class="vs-table vs-table--tbody-table"
    >
      <thead class="vs-table--thead">
        <tr>
          <th>Anrede</th>
          <th>Name</th>
          <th>Position</th>
          <th>Abteilung</th>
          <th>Telefon</th>
          <th>E-Mail</th>
        </tr>
      </thead>
      <tbody class="vs-table--tbody">
        <template v-for="contact of companyContactPartnersPage.results">
          <tr :key="contact.id">
            <td>
              <template v-if="contact.salutation == `MR`">Herr</template>
              <template v-else-if="contact.salutation == `MRS`">Frau</template>
              <template v-else>-</template>
            </td>
            <td>{{ contact.firstName }} {{ contact.lastName }}</td>
            <td>{{ contact.position }}</td>
            <td>{{ contact.department }}</td>
            <td>
              <a
                v-if="contact.telephone"
                :href="`callto:${contact.telephone}`"
                >{{ contact.telephone }}</a
              >
              <template v-if="contact.telephoneMobile"
                ><br /><a :href="`callto:${contact.telephoneMobile}`">{{
                  contact.telephoneMobile
                }}</a></template
              >
            </td>
            <td>
              <a v-if="contact.email" :href="`mailto:${contact.email}`">{{
                contact.email
              }}</a>
            </td>
          </tr>
          <tr
            v-if="$store.getters['user/hasPermission']('newsletter_companies')"
            :key="contact.id + '1'"
          >
            <td colspan="100">
              <div class="custom-accordion">
                <div
                  class="custom-accordion--item"
                  :class="{
                    'is-active': syncOpen[contact.id]
                  }"
                >
                  <button
                    class="custom-accordion--header"
                    @click="
                      () => (syncOpen[contact.id] = !syncOpen[contact.id])
                    "
                  >
                    Mit Cleverreach synchronisieren
                    <i class="far fa-chevron-down"></i>
                  </button>
                  <div v-if="syncOpen[contact.id]" class="accordion-content">
                    <cleverreach-sync-contact
                      :company-contact-i-d="contact.id"
                    ></cleverreach-sync-contact>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import gql from "graphql-tag";
import CleverreachSyncContact from "../form/CleverreachSyncContact.vue";

export default {
  components: { CleverreachSyncContact },
  data() {
    return {
      syncOpen: {}
    };
  },
  watch: {
    companyContactPartnersPage: {
      deep: true,
      immidiate: true,
      handler(value) {
        let result = {};
        if (value && value.results) {
          for (let contact of value.results) {
            result[contact.id] = false;
          }
          this.syncOpen = result;
        }
      }
    }
  },
  apollo: {
    companyContactPartnersPage: {
      query: gql`
        query Company($company: ID!) {
          companyContactPartnersPage(company: $company) {
            results {
              id
              salutation
              firstName
              lastName
              position
              department
              telephone
              telephoneMobile
              email
            }
          }
        }
      `,
      variables() {
        return {
          company: this.$route.params.id
        };
      }
    }
  }
};
</script>
<style scoped>
.accordion-content {
  overflow: hidden;
  transition: height 0.2s ease-out;
}
</style>
